<template lang="es">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="claveParada"
          label="Contraseña numérica para parar el horno"
          inputmode="numeric"
          pattern="[0-9]*"
          :success="guardado"
          :error-messages="error ? ['Error al guardar'] : []"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="d-flex align-center">
        <v-btn color="primary" @click="guardar">Guardar</v-btn>
        <span v-if="guardado" class="ml-3 success--text">Guardado</span>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      claveParada: "0",
      guardado: false,
      error: false,
    };
  },
  methods: {
    ...mapActions("api", ["getAjuste", "updateAjuste"]),
    async cargar() {
      try {
        const res = await this.getAjuste("clave_parada");
        this.claveParada = (res.data && res.data.valor != null) ? res.data.valor : "0";
      } catch (e) {
        this.claveParada = "0";
      }
    },
    async guardar() {
      this.guardado = false;
      this.error = false;
      try {
        await this.updateAjuste({ clave: "clave_parada", valor: this.claveParada });
        this.guardado = true;
      } catch (e) {
        this.error = true;
      }
    },
  },
  created() {
    this.cargar();
  },
};
</script>
<style lang="">
</style>
